import { Grid } from '@mui/material';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { useCasesGeneralInformationForm } from './hook';
import { CasesGeneralInformationCallInfo } from './callInfo';
import FormView from '../../../../components/views/formView';
import { CasesGeneralInformationFormProps } from './props';

export const CasesGeneralInformationForm = ({
    showFormView,
    account,
}: CasesGeneralInformationFormProps) => {
    const {
        casesGeneralInformation,
        loading,
        handleSubmit,
        handleClean,
        setFormikCasesGeneralInformation,
    } = useCasesGeneralInformationForm();

    return (
        <>
            {showFormView && (
                <FormView
                    title={
                        casesGeneralInformation && casesGeneralInformation.id
                            ? 'Editar PQR'
                            : 'Crear PQR'
                    }
                />
            )}
            <CasesGeneralInformationCallInfo
                data={casesGeneralInformation}
                onChangeFormik={(formik) =>
                    setFormikCasesGeneralInformation(formik)
                }
                account={account}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!casesGeneralInformation || !casesGeneralInformation.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
        </>
    );
};
